import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ban, Flag, Gift, MessageCircle, MoreHorizontal, UserCheck, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import BlockConfirmDialog from "@/components/BlockConfirmDialog";
import ReportModal from "@/components/ReportModal";

const stop = (e) => { e.stopPropagation(); e.preventDefault(); };

// Stable "⋯" action menu for a Social Meet card. Never sits under the natural tap point
// (top-right corner), every item stops propagation, Block always confirms first.
export default function MemberActionsMenu({ m, onFollow, onRemove, onLeave }) {
  const navigate = useNavigate();
  const [blockOpen, setBlockOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const go = (to) => { onLeave?.(); navigate(to); };
  const item = "gap-2.5 py-2.5 text-sm focus:bg-white/10 cursor-pointer";
  return (
    <div className="absolute top-1.5 right-1.5 z-10" onClick={stop} onPointerDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button data-testid={`member-actions-${m.id}`} variant="ghost" aria-label={`Actions for ${m.display_name}`} className="h-8 w-8 p-0 rounded-full bg-black/65 backdrop-blur border border-white/20 text-white hover:bg-black/80">
            <MoreHorizontal size={16} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={6} className="bg-zinc-950 border-white/10 text-white min-w-[190px] z-[1300]" data-testid={`member-actions-menu-${m.id}`} onClick={stop}>
          <DropdownMenuItem data-testid={`member-follow-${m.id}`} onSelect={() => onFollow(m)} className={item}>
            {m.is_following ? <UserCheck size={15} /> : <UserPlus size={15} className="text-rose-400" />} {m.is_following ? "Unfollow" : "Follow"}
          </DropdownMenuItem>
          <DropdownMenuItem data-testid={`member-message-${m.id}`} onSelect={() => go(`/inbox?to=${m.id}`)} className={item}><MessageCircle size={15} /> Message</DropdownMenuItem>
          <DropdownMenuItem data-testid={`member-gift-${m.id}`} onSelect={() => go(`/u/${m.id}?gift=1`)} className={item}><Gift size={15} className="text-amber-300" /> Send a gift</DropdownMenuItem>
          <DropdownMenuSeparator className="bg-white/10" />
          <DropdownMenuItem data-testid={`member-report-${m.id}`} onSelect={() => setReportOpen(true)} className={`${item} text-rose-300`}><Flag size={15} /> Report</DropdownMenuItem>
          <DropdownMenuItem data-testid={`member-block-${m.id}`} onSelect={() => setBlockOpen(true)} className={`${item} text-rose-300`}><Ban size={15} /> Block…</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ReportModal open={reportOpen} onOpenChange={setReportOpen} target={{ type: "user", id: m.id }} onBlocked={onRemove} />
      <BlockConfirmDialog open={blockOpen} onOpenChange={setBlockOpen} targetRef={m.id} name={m.display_name} onBlocked={onRemove} testid={`member-block-${m.id}`} />
    </div>
  );
}
